module.exports = __webpack_public_path__ + "img/messorem.fb7207b6.svg";